import {createSelector} from 'reselect';
import props from './props';

export default createSelector(
    props.user.isAuth,
    props.app.affiliate_bonus,
    props.user.welcome_bonus,
    props.games.games,
    (isAuth, affiliate_bonus, welcome_bonus, games) => {
        if(!isAuth)
            return {
                type: (affiliate_bonus && affiliate_bonus.type === 'affiliate') ? 'affiliate' : null,
                games
            }

        return {
            type: welcome_bonus.type,
            games
        }
    }
)